import { mapState } from 'vuex'
import UserEdit from '@/components/user/edit/UserEdit.vue'

export default {
  name: 'ClientUserList',
  props: ['clientApiId', 'data', 'pagingData', 'client'],
  data () {
    return {
      loading: true,
      users: null,
      paging: {
        limit: 10,
        page: 1,
        total: 0,
        pages: 0
      }
    }
  },
  components: {
    UserEdit
  },
  computed: {
    ...mapState(['config']),
    tableHeaders () {
      const headers = [
        { key: 'name', label: this.$t('user.name') },
        { key: 'phones', label: this.$t('user.phone'), format: 'formatPhones' },
        { key: 'email', label: this.$t('user.email'), format: 'formatEmail' },
        { key: 'pivot.jobPosition', label: this.$t('user.jobPosition') },
        { key: 'pivot.canFillReports', label: this.$t('user.pivot.canFillReports'), format: 'formatYesNo' },
        { key: 'pivot.isContactPerson', label: this.$t('user.pivot.isContactPerson'), format: 'formatYesNo' },
        { key: 'pivot.isResponsiblePerson', label: this.$t('user.pivot.isResponsiblePerson'), format: 'formatYesNo' },
        { key: 'pivot.receiveBill', label: this.$t('user.pivot.receiveBill'), format: 'formatYesNo' },
        { key: 'pivot.receiveNotifications', label: this.$t('user.pivot.receiveNotifications'), format: 'formatYesNo' }
      ];
      if (this.canEdit) {
        const actions = [
          { label: this.$t('menu.user.edit'), emit: 'editUser', icon: 'edit', bicon: 'pencil-fill' },
          { label: this.$t('menu.user.delete'), emit: 'deleteClientUser', icon: 'delete_forever', bicon: 'trash' }
        ];
        if (this.ApiRequest.userHasPermission('simulate-users')) {
          actions.push({ label: this.$t('menu.user.simulate'), emit: 'simulateUser', bicon: 'person-fill', ifconfig: { useFunc: true, func: function (el) { return !(el.roles && el.roles.find(role => role.name === 'admin')) } } })
        }
        headers.push({ key: 'actions', label: '', actions: actions });
      }
      return headers;
    },
    canEdit () {
      return true;
    }
  },
  methods: {
    changePage (pageNr) {
      this.paging.page = pageNr;
      this.loading = true;
      this.$forceUpdate();
      const path = 'client/single/' + this.clientApiId + '/users/?perPage=' + this.paging.limit + '&page=' + pageNr;
      const self = this;
      this.ApiRequest.request(path, this.ApiRequest.REQUEST_GET, [], function (response) {
        if (response.data) {
          self.users = response.data;
          self.limit = response.paging.limit;
          self.total = response.paging.total;
          self.page = response.paging.page;
          self.pages = response.paging.pages;
        }
        self.loading = false;
        self.$forceUpdate();
      })
    },
    editUser (user) {
      this.$refs.userEdit.show(user, this.clientApiId);
    },
    deleteClientUser (user, confirmed = false) {
      if (confirmed) {
        this.loading = true;
        const self = this;
        const path = 'client/single/' + self.clientApiId + '/user/delete';
        this.ApiRequest.request(path, this.ApiRequest.REQUEST_POST, { user: user.api_id }, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
            self.loading = false;
          } else {
            self.changePage(self.paging.page);
          }
        });
      } else {
        this.$refs.clientDeleteMsgBox.show(user, this.$t('client.user.deleteTitle'), this.$t('client.user.deleteMessage', { userName: user.name, clientName: this.client.name }))
      }
    },
    simulateUser (el, approved = false) {
      if (approved) {
        this.ApiRequest.simulateUser(el, this);
      } else {
        this.$refs.userSimulateMsgBox.show(el, this.$t('user.simulate.title'), this.$t('user.simulate.message', { userName: el.name, email: el.email }))
      }
    }
  },
  mounted () {
    if (this.data) {
      this.users = this.data;
      this.paging = this.pagingData;
      this.loading = false;
    } else {
      this.changePage(this.paging.page);
    }
  }
}
